/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminWorkerRunJob = {
    WorkerRunJobMarketRefresh: 'market_refresh',
    WorkerRunJobListingChecks: 'listing_checks',
    WorkerRunJobRecomputeAll: 'recompute_all',
    WorkerRunJobEbayOrders: 'ebay_orders'
} as const;
export type AdminWorkerRunJob = typeof AdminWorkerRunJob[keyof typeof AdminWorkerRunJob];


export function instanceOfAdminWorkerRunJob(value: any): boolean {
    for (const key in AdminWorkerRunJob) {
        if (Object.prototype.hasOwnProperty.call(AdminWorkerRunJob, key)) {
            if (AdminWorkerRunJob[key as keyof typeof AdminWorkerRunJob] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminWorkerRunJobFromJSON(json: any): AdminWorkerRunJob {
    return AdminWorkerRunJobFromJSONTyped(json, false);
}

export function AdminWorkerRunJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerRunJob {
    return json as AdminWorkerRunJob;
}

export function AdminWorkerRunJobToJSON(value?: AdminWorkerRunJob | null): any {
    return value as any;
}

export function AdminWorkerRunJobToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminWorkerRunJob {
    return value as AdminWorkerRunJob;
}

